import React from "react";
import {
    Grid,
    Button
} from '@material-ui/core';

import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';

const classes = {
    buttonClear: {
        backgroundColor: '#F5F5F5',
        color: '#174FB3',
        borderRadius: 20,
        height: '45px',
        textTransform: 'capitalize',
        fontFamily: 'Rawline',
        fontWeight: 'bold',
        fontSize: 15,
        minWidth: '220px'
    },
    buttonConfirm: {
        backgroundColor: '#1551B3',
        color: '#fff',
        borderRadius: 20,
        height: '45px',
        textTransform: 'capitalize',
        fontFamily: 'Rawline',
        fontWeight: 'bold',
        fontSize: 15,
        minWidth: '220px'
    }
};

export default function ControlButtons({ issueReport }) {
    return (
        <Grid container spacing={2} item justifyContent='center' >
            <Grid item>
                <Button
                    id="cancelButton"
                    variant="outlined"
                    startIcon={<CloseIcon style={{ 'color': '#174FB3' }} />}
                    type='button'
                    style={classes.buttonClear}
                >
                    CANCELAR
                </Button>
            </Grid>

            <Grid item>
                <Button
                    id="emitirButton"
                    variant="outlined"
                    startIcon={<PrintIcon style={{ 'color': '#fff' }} />}
                    onClick={issueReport}
                    style={classes.buttonConfirm}
                >
                    EMITIR RELATÓRIO
                </Button>
            </Grid>
        </Grid>
    );
}